<template>
  <div id="tsIndex">
    <!--超级管理员-->
    <Row v-if="users_type==1" style="float: left;width: 100%">
      <Col>
        <Card>
          <p slot="title">稿件统计</p>
          <div style="background:#F0F2F5;">
            <!--超级管理员-->
            <Row v-if="users_type==1" type="flex" justify="space-between">
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">稿件总数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.count ? materialTjInfo.count : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">初审中稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.onecount ? materialTjInfo.onecount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">复审中稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.sixcount ? materialTjInfo.sixcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">外审中稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.sevencount ? materialTjInfo.sevencount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">终审中稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.eightcount ? materialTjInfo.eightcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">作者修改中稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.twocount ? materialTjInfo.twocount : 0 }}</p>
                </Card>
              </Col>
            </Row>
            <!--管理编辑-->
            <Row v-if="users_type==2&&userData.user_type_status==1" type="flex" justify="space-between">
              <Col span="6" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已收到稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.count ? materialTjInfo.count : 0 }}</p>
                </Card>
              </Col>
              <Col span="6" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已退修重审的稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.twocount ? materialTjInfo.twocount : 0 }}</p>
                </Card>
              </Col>
              <Col span="6" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已录用稿件数量 </p>
                  <p>{{ materialTjInfo && materialTjInfo.fourcount ? materialTjInfo.fourcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="6" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已退稿稿件数量 </p>
                  <p>{{ materialTjInfo && materialTjInfo.fivecount ? materialTjInfo.fivecount : 0 }}</p>
                </Card>
              </Col>
            </Row>
            <!--普通编辑-->
            <Row v-if="(users_type==2&&userData.user_type_status==2)||users_type==3" type="flex" justify="space-between">
              <Col span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已收到稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.count ? materialTjInfo.count : 0 }}</p>
                </Card>
              </Col>
              <Col span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已通过稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.tencount ? materialTjInfo.tencount : 0 }}</p>
                </Card>
              </Col>
              <Col span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已驳回稿件数量 </p>
                  <p>{{ materialTjInfo && materialTjInfo.elevencount ? materialTjInfo.elevencount : 0 }}</p>
                </Card>
              </Col>
            </Row>
            <!--作者-->
            <Row v-if="users_type==4" type="flex" justify="space-between">
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的稿件总数</p>
                  <p>{{ materialTjInfo && materialTjInfo.count ? materialTjInfo.count : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的初审稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.onecount ? materialTjInfo.onecount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的复审稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.sixcount ? materialTjInfo.sixcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的外审稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.sevencount ? materialTjInfo.sevencount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的终审稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.eightcount ? materialTjInfo.eightcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="4" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的修改中稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.twocount ? materialTjInfo.twocount : 0 }}</p>
                </Card>
              </Col>
            </Row>
            <Row v-if="users_type==4" type="flex" justify="space-between" style="width: 50%">
              <Col span="8" style="padding:0px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">我的修回稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.threecount ? materialTjInfo.threecount : 0 }}</p>
                </Card>
              </Col>
              <Col span="8" style="padding:0px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已录用稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.fourcount ? materialTjInfo.fourcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="8" style="padding:0px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已退稿稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.fivecount ? materialTjInfo.fivecount : 0 }}</p>
                </Card>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
    <Row v-if="users_type==1" style="width: 50%;float: left;margin-top: 15px;" >
      <Col>
        <Card>
          <p slot="title">稿件统计</p>
          <div style="background:#F0F2F5;">
            <!--超级管理员-->
            <Row type="flex" justify="space-between">
              <Col span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">作者已修回稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.threecount ? materialTjInfo.threecount : 0 }}</p>
                </Card>
              </Col>
              <Col span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已录用稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.fourcount ? materialTjInfo.fourcount : 0 }}</p>
                </Card>
              </Col>
              <Col span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">已退稿稿件数量</p>
                  <p>{{ materialTjInfo && materialTjInfo.fivecount ? materialTjInfo.fivecount : 0 }}</p>
                </Card>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
    <Row v-if="users_type==1" style="float: left;width: 50%;margin-top: 15px">
      <Col>
        <Card>
          <p slot="title">用户统计</p>
          <div style="background:#F0F2F5;">
            <Row type="flex" justify="space-around">
              <Col v-if="users_type==1" span="8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">编辑总数</p>
                  <p>{{ userTjInfo && userTjInfo.teachercount ? userTjInfo.teachercount : 0 }}</p>
                </Card>
              </Col>
              <Col :span="users_type==2?12:8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">专家总数</p>
                  <p>{{ userTjInfo && userTjInfo.zhuanjiacount ? userTjInfo.zhuanjiacount : 0 }}</p>
                </Card>
              </Col>
              <Col :span="users_type==2?12:8" style="padding:29px 10px 17px 10px;">
                <Card shadow style="height:104px;text-align: center;">
                  <p slot="title">作者总数</p>
                  <p>{{ userTjInfo && userTjInfo.tougaorencount ? userTjInfo.tougaorencount : 0 }}</p>
                </Card>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
    <!--作者-->
    <Card v-if="users_type==4" style="width:88px;float: left">
      <Button type="primary" @click="addData">投稿</Button>
    </Card>
    <Card v-if="users_type==4" style="width: calc(100% - 100px);float: left">
      <p slot="title">投稿进度</p>
      <div>
        <Table border stripe :loading="tableLoading" :columns="columns" :data="data"></Table>
        <p v-if="data.length>10" style="width: 100%;margin-top: 18px;text-align: end;cursor: pointer;" @click="goDataManage({
        path:'dataManage',title:'稿件管理'
        })">查看更多>></p>
      </div>
    </Card>
    <!--专家、编辑-->
    <Row v-if="users_type==2||users_type==3" type="flex" justify="space-around">
      <Col v-if="users_type==2||users_type==3"  :style="{width:users_type==2?'calc(calc(100% / 3) - 5px)':'calc(50% - 5px)'}">
        <Card>
          <p slot="title">待办稿件</p>
          <div>
            <Table border stripe :loading="tableLoading_db" :columns="columns_db_yb_zzb" :data="data_db"></Table>
            <p v-if="data_db.length>10" style="width: 100%;margin-top: 18px;text-align: end;cursor: pointer;" @click="goDataManage({
        path:'doHandledb',title:'待办稿件'
        })">查看更多>></p>
          </div>
        </Card>
      </Col>
      <Col v-if="users_type==2" :style="{width:users_type==2?'calc(calc(100% / 3) - 5px)':'calc(50% - 5px)'}">
        <Card>
          <p slot="title">正在办稿件</p>
          <div>
            <Table border stripe :loading="tableLoading_zzb" :columns="columns_db_yb_zzb" :data="data_zzb"></Table>
            <p v-if="data_zzb.length>10" style="width: 100%;margin-top: 18px;text-align: end;cursor: pointer;" @click="goDataManage({
        path:'doHandlezzb',title:'正在办稿件'
        })">查看更多>></p>
          </div>
        </Card>
      </Col>
      <Col v-if="users_type==2||users_type==3" :style="{width:users_type==2?'calc(calc(100% / 3) - 5px)':'calc(50% - 5px)'}">
        <Card>
          <p slot="title">已办稿件</p>
          <div>
            <Table border stripe :loading="tableLoading_yb" :columns="columns_db_yb_zzb" :data="data_yb"></Table>
            <p v-if="data_yb.length>10" style="width: 100%;margin-top: 18px;text-align: end;cursor: pointer;" @click="goDataManage({
        path:'doHandleyb',title:'已办稿件'
        })">查看更多>></p>
          </div>
        </Card>
      </Col>
    </Row>

    <aqt-sidebar v-model="show" :title="titles" ref="child">
      <component :is="content" :infoData="infoData" :userType="users_type" @operationState="operationState"></component>
    </aqt-sidebar>

    <Modal :width="350" v-model="fenpeiModal" :title="titles">
      <Select v-model="fpform.zhuanjia_id" :placeholder="`${$t('m.please_select')+$t('m.reviewer')}`" filterable clearable>
        <Option v-for="(item, index) in teacherList" :value="item.users_id" :key="index">{{ item.name }}</Option>
      </Select>
      <div slot="footer">
        <Button type="primary" @click="fenpeiOk" :loading="fpLoading" :disabled="fpform.zhuanjia_id?false:true">确定</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
export default {
  components: {
    Operation: resolve => {require(['@/views/dataManage/Operation.vue'], resolve);},
    CheckData: resolve => {require(['@/views/dataManage/CheckData.vue'], resolve);},
    printCheck: resolve => {require(['@/views/dataManage/printCheck.vue'], resolve);},
  },
  data() {
    return {
      users_type: localStorage.getItem('user_type'),//1管理员2编辑 3专家 4作者
      materialTjInfo: '',
      userTjInfo: '',
      userData: '',

      tableLoading:false,
      columns:[
        {
          title: '标题(蒙古文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', {
              class: {
                'contentfont': true,
              }
            },params.row.titlelang&&params.row.titlelang.mn?params.row.titlelang.mn.slice(0, 100):'')
          }
        },
        {
          title: '标题(中文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.titlelang&&params.row.titlelang.zh?params.row.titlelang.zh.slice(0, 50):'')
          }
        },
        {
          title: '标题(英文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', params.row.titlelang&&params.row.titlelang.en?params.row.titlelang.en.slice(0, 100):'')
          }
        },
        {
          title: '投稿时间',
          width: 150,
          align: 'center',
          key: 'created_at',
        },
        {
          title: '当前阶段',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getstatusName(params.row.stage)+'（'+this.getstatusName(params.row.status)+'）')
          }
        }
      ],
      data:[],
      statusList:[
        {
          name:'未审核',
          lebal:0
        },
        {
          name:'初审',
          lebal:1
        },
        {
          name:'作者修改中',
          lebal:2
        },
        {
          name:'作者修回稿件',
          lebal:3
        },
        {
          name:'已录用稿件',
          lebal:4
        },
        {
          name:'已退稿件 ',
          lebal:5
        },
        {
          name:'复审',
          lebal:6
        },
        {
          name:'外审',
          lebal:7
        },
        {
          name:'终审',
          lebal:8
        },
        {
          name:'审核中',
          lebal:9
        }
      ],
      show: false,
      titles: '',
      content: '',
      infoData:false,

      columns_db_yb_zzb:[
        {
          title: '标题(蒙古文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', {
              class: {
                'contentfont': true,
              }
            },params.row.titlelang&&params.row.titlelang.mn?params.row.titlelang.mn.slice(0, 100):'')
          }
        },
        {
          title: '标题(中文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.titlelang&&params.row.titlelang.zh?params.row.titlelang.zh.slice(0, 50):'')
          }
        },
        {
          title: '标题(英文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', params.row.titlelang&&params.row.titlelang.en?params.row.titlelang.en.slice(0, 100):'')
          }
        },
        // {
        //   title: '投稿时间',
        //   width: 100,
        //   align: 'center',
        //   key: 'created_at',
        // },
        {
          title: '当前阶段',
          width: 120,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getstatusName(params.row.stage)+'（'+this.getstatusName(params.row.status)+'）')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  margin: '2px',
                },
                on: {
                  click: () => {
                    this.infoData = params.row.manuscript_id;
                    this.content = 'CheckData';
                    this.titles = '查看';
                    this.show = true;
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                style: {
                  margin: '2px',
                  display:this.users_type==2&&this.userData.user_type_status==1&&params.row.zhuanjia_id==0?'inline-table':'none'
                },
                on: {
                  click: () => {
                    this.fpform.id = JSON.stringify([params.row.manuscript_id]);
                    this.fenpeiModal = true
                    this.fpform.zhuanjia_id = ''
                    this.titles = this.$t('m.fpexpert')
                  }
                }
              }, '分配'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                style: {
                  margin: '2px',
                  display:this.userData.users_id==params.row.chushen_id&&(params.row.status==4||params.row.status==5)?'inline-table':'none',//当前用户id = 初审人id
                },
                on: {
                  click: () => {
                    this.infoData = params.row.manuscript_id;
                    this.content = 'printCheck';
                    this.titles = '打印';
                    this.show = true;
                  }
                }
              }, '打印'),
            ]);
          }
        }
      ],
      data_db:[],
      tableLoading_db:false,

      data_yb:[],
      tableLoading_yb:false,

      data_zzb:[],
      tableLoading_zzb:false,

      fpform:{
        zhuanjia_id:'',
        id:'',
        library_id:localStorage.getItem('libId'),
        users_type:localStorage.getItem('user_type'),
      },
      fpLoading:false,
      fenpeiModal:false,
      teacherList:[],
    }
  },
  methods: {
    getStatistics() {
      const _this = this
      let cond = {
        library_id: localStorage.getItem('libId'),
      }
      //稿件统计
      _this.$httpsencrypt.post(`api/contributeweb/v3/statistics/ManuscriptTj`, cond)
          .then(val => {
            if (val.code == 200) {
              _this.materialTjInfo = val.data
            }
          }).catch(err => {
        _this.materialTjInfo = ''
      })
      if (_this.users_type == 3 || _this.users_type == 4) {
        return
      }
      //用户统计
      _this.$httpsencrypt.post(`api/contributeweb/v3/statistics/UsersTj`, cond)
          .then(val => {
            if (val.code == 200) {
              _this.userTjInfo = val.data
            }
          }).catch(err => {
        _this.userTjInfo = ''
      })
    },

    getstatusName (value) {
      let gg = this.statusList.find(i => {
        return i.lebal == value
      });
      return gg?gg.name:'';
    },
    goDataManage(e){
      this.$router.push({
        path:`/${e.path}`,
        query:{
          lib:this.$route.query.lib,
          alis:this.$route.query.alis
        }
      })
      let data = localStorage.getItem('tabList') ? JSON.parse(this.$crypto.get(localStorage.getItem('tabList'))) : []
      if (data.length) {
        let bool = data.find(el => el.value === e.path)
        if (bool) {
        } else {
          data.push({
            label: e.title,
            value: e.path
          })
          this.handelLocalStorage(data, e.path)
        }
      } else {
        let arr = [
          {
            label: e.title,
            value: e.path
          }
        ]
        this.handelLocalStorage(arr, e.path)
      }

    },
    handelLocalStorage(data, path) {
      localStorage.setItem('tabList', this.$crypto.set(JSON.stringify(data)))
      this.updataStoreTabList()
    },
    updataStoreTabList() {
      this.$store.state.tabList = this.$crypto.get(localStorage.getItem('tabList'))
    },
    //投稿
    addData () {
      this.infoData = false
      this.content = 'Operation'
      this.titles = '上传资料'
      this.show = true
    },
    //弹框关闭调用的事件
    operationState (data,isindex=false) {
      if (data) this.show = false
      if(isindex){
        //编辑
        if(this.users_type==2){
          this.getDbList()
          this.getZzbList()
          this.getYbList()
        }
        //专家
        if(this.users_type==3){
          this.getDbList()
          this.getYbList()
        }
      }else {
        this.goDataManage ({
          path:'dataManage',title:'稿件管理'
        })
      }

    },

    //作者的投稿进度
    getAtourTgjd(){
      const _this = this
      _this.tableLoading = true
      let cond = {
        library_id:localStorage.getItem('libId'),
        page:1,
        gjstatus:2,//不传是全部 1待办 2正办 3已办
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscript/list`,cond)
          .then(val =>{
            _this.data = val.data;
            _this.tableLoading = false;
          }).catch(err =>{
        _this.data = []
        _this.tableLoading=false;
      })
    },

    //待办稿件
    getDbList(){
      const _this = this
      _this.tableLoading_db = true
      let cond = {
        library_id:localStorage.getItem('libId'),
        page:1,
        gjstatus:1,//不传是全部 1待办 2正办 3已办
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscript/list`,cond)
          .then(val =>{
            _this.data_db = val.data;
            _this.tableLoading_db = false;
          }).catch(err =>{
        _this.data_db = []
        _this.tableLoading_db=false;
      })
    },
    //正在办稿件
    getZzbList(){
      const _this = this
      _this.tableLoading_zzb = true
      let cond = {
        library_id:localStorage.getItem('libId'),
        page:1,
        gjstatus:2,//不传是全部 1待办 2正办 3已办
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscript/list`,cond)
          .then(val =>{
            _this.data_zzb = val.data;
            _this.tableLoading_zzb = false;
          }).catch(err =>{
        _this.data_zzb = []
        _this.tableLoading_zzb=false;
      })
    },
    //已办稿件
    getYbList(){
      const _this = this
      _this.tableLoading_yb = true
      let cond = {
        library_id:localStorage.getItem('libId'),
        page:1,
        gjstatus:3,//不传是全部 1待办 2正办 3已办
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscript/list`,cond)
          .then(val =>{
            _this.data_yb = val.data;
            _this.tableLoading_yb = false;
          }).catch(err =>{
        _this.data_yb = []
        _this.tableLoading_yb=false;
      })
    },
    // 获取评审人
    getExperList(){
      const _this = this
      let cond1 = {
        library_id:localStorage.getItem('libId'),
        user_type:2
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/index`,cond1)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.teacherList = val.data
            }else {
              _this.teacherList = []
            }
          }).catch(err =>{
        _this.teacherList = []
      })
    },
    //分配评审人
    fenpeiOk(){
      this.fpLoading = true
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/fpzj' ,this.fpform).then(val=>{
        this.fenpeiModal = false
        this.fpLoading = false
        this.getDbList()
        this.getZzbList()
        this.$Message.success('分配成功!');
      }).catch(err => {
        this.fenpeiModal = false
        this.fpLoading = false
        this.$Message.error('分配失败!');
      })
    },

  },
  mounted() {
    this.userData = JSON.parse(this.userInfo)
    if(this.users_type==1){
      this.getStatistics()
    }
    //作者
    if(this.users_type==4){
      this.getAtourTgjd()
    }
    //编辑
    if(this.users_type==2){
      this.getDbList()
      this.getZzbList()
      this.getYbList()
      this.getExperList()
    }
    //专家
    if(this.users_type==3){
      this.getDbList()
      this.getYbList()
    }

  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  watch: {
    userInfo: {
      handler(val, oldValue) {
        this.userData = val ? JSON.parse(val) : ''
      },
      deep: true
    }
  },
}
</script>

<style lang="less" scoped>
#tsIndex {
  width: 100%;
  height: 100%;
  padding: 8px;
  position: relative;
  overflow-y: auto;
  background: #F0F2F5;
}
</style>
